import Contact, { type IContactProps } from './Contact'
import ContactPure, { type IContactPureProps } from './ContactPure'

export { Contact, ContactPure, type IContactProps, type IContactPureProps }
